export function Page({ title, subtitle, children }) {
  return (
    <main className="page">
      <div className="page-heading">
        <div>
          <p className="eyebrow">TRUE VISION WORKSPACE</p>
          <h1>{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
        <div className="page-sun">✦</div>
      </div>
      {children}
    </main>
  );
}
